"use strict";
exports.__esModule = true;
exports.RowLegend = exports.RowLegendIcoButton = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var LegendLabelItem_1 = require("../LegendLabelItem");
var LegendList_1 = require("../LegendList");
var LEGEND_ROW_HEIGHT = 20;
var LEGEND_TOP_BOTTOM_PADDING = 10;
var useCheckOverflow = function () {
    var _a = react_1.useState(false), isOverflow = _a[0], setOverFlow = _a[1];
    var _b = react_1.useState(1), numOfUsedRow = _b[0], setNumOfUsedRow = _b[1];
    var getNumberOfRows = function (clientHeight) {
        return Math.ceil((clientHeight - LEGEND_TOP_BOTTOM_PADDING) / LEGEND_ROW_HEIGHT);
    };
    var checkOverFlow = function (element) {
        if (!element)
            return;
        var clientHeight = element.clientHeight, scrollHeight = element.scrollHeight;
        setOverFlow(scrollHeight > clientHeight);
        var numberOfRows = getNumberOfRows(clientHeight);
        setNumOfUsedRow(numberOfRows);
    };
    return [isOverflow, numOfUsedRow, checkOverFlow];
};
exports.RowLegendIcoButton = function (props) {
    var isVisible = props.isVisible, isActive = props.isActive, onIconClick = props.onIconClick;
    if (!isVisible) {
        return null;
    }
    var handleOnClick = function (e) {
        e.stopPropagation();
        onIconClick();
    };
    var iconClasses = classnames_1["default"]("legend-popup-icon s-legend-popup-icon", {
        "legend-popup-icon-active": isActive
    });
    return (react_1["default"].createElement("div", { className: "legend-popup-button" },
        react_1["default"].createElement("div", { onClick: handleOnClick, className: iconClasses },
            react_1["default"].createElement(sdk_ui_kit_1.Icon.LegendMenu, null))));
};
exports.RowLegend = function (props) {
    var series = props.series, _a = props.maxRowsCount, maxRowsCount = _a === void 0 ? 1 : _a, legendLabel = props.legendLabel, enableBorderRadius = props.enableBorderRadius, onDialogIconClick = props.onDialogIconClick, onLegendItemClick = props.onLegendItemClick, _b = props.isActive, isActive = _b === void 0 ? false : _b;
    var _c = useCheckOverflow(), isOverflow = _c[0], numOfUsedRow = _c[1], checkOverFlow = _c[2];
    var LEGEND_HEIGHT = maxRowsCount * LEGEND_ROW_HEIGHT + LEGEND_TOP_BOTTOM_PADDING;
    var itemsAlign = numOfUsedRow === 1 ? "flex-end" : "flex-start";
    return (react_1["default"].createElement("div", { className: "legend-popup-row", style: { maxHeight: LEGEND_HEIGHT } },
        react_1["default"].createElement("div", { className: "viz-legend static position-row" },
            react_1["default"].createElement("div", { className: "series", style: {
                    justifyContent: itemsAlign
                }, ref: function (element) {
                    checkOverFlow(element);
                } },
                react_1["default"].createElement(LegendLabelItem_1.LegendLabelItem, { label: legendLabel }),
                react_1["default"].createElement(LegendList_1.LegendList, { enableBorderRadius: enableBorderRadius, series: series, onItemClick: onLegendItemClick }))),
        react_1["default"].createElement(exports.RowLegendIcoButton, { isActive: isActive, isVisible: isOverflow, onIconClick: onDialogIconClick })));
};
//# sourceMappingURL=RowLegend.js.map